//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ErrorDisplay from '../../common/ErrorDisplay.vue';
import Logo from '../../common/svg/Logo';

export default {
  components: {
    Logo,
    ErrorDisplay,
  },
  props: [
    'defaultUsername',
  ],
  data() {
    return {
      username: this.defaultUsername,
      resetConfirmed: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    async passwordReset() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch('initiateForgotPassword', this.username);
        console.log('Password reset successful:', result);
        this.resetConfirmed = true;
        await this.showModal();
      } catch (error) {
        this.error = error;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async showModal() {
      await this.confirmation({
        message: 'Password reset requested. Check your email for the confirmation code.',
        messageSize: 'h5 has-text-gray',
        confirmType: 'success',
        confirmText: 'OK',
        showCancel: false,
      });
      this.modalHidden();
    },
    modalHidden() {
      if (this.resetConfirmed) {
        this.$router.replace({
          name: 'passwordResetConfirm',
          params: { defaultUsername: this.username },
        });
      }
    },
  },
};
